<div *adaptLoadingUntilFirstEmit="let values of values$">
    @if (values.length > 0) {
        <div class="values-grid">
            @for (value of values; track value) {
                <div class="value">
                    <h3 class="text-center mb-2">{{ value.name }}</h3>
                    <div [froalaView]="value.meaning"></div>
                </div>
            }
        </div>
    } @else {
        <adapt-call-to-action-inline [featureUrl]="vcUrl$ | async"> Adapt's values tool provides a place to capture and maintain your
            organisation's values. </adapt-call-to-action-inline>
    }
</div>
